import { useEffect } from "react";

const PreloadImages = () => {
  useEffect(() => {
    // Preload critical hero image
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = '/lovable-uploads/2ed320a6-d7dd-4a96-a88d-796b60d9d77b.png';
    link.type = 'image/png';
    (link as any).fetchPriority = 'high';
    document.head.appendChild(link);

    return () => {
      if (link.parentNode) {
        document.head.removeChild(link);
      }
    };
  }, []);

  return null;
};

export default PreloadImages;